import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Autocomplete,
    Card,
    CardContent, CardHeader, Divider, Grid, Link, Table,
    TableBody,
    TableCell, TableRow, TextField, Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { ComuneContext } from '../ComuneContext';

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const ComuneSchema = Yup.object().shape({
    denominazioneIt: Yup.string().required("La denominazione è un campo obbligatorio"),
    codIstat: Yup.string().required("Il codice istat è un campo obbligatorio"),
    codCatastale: Yup.string().required("Il codice catastale è un campo obbligatorio"),
});

export const ComuneDetails = ({
    formRef,
    disabled,
    onActionClick,
    ...props }) => {

    const {
        state,
        setState,
    } = useContext(ComuneContext);

    const {
        comune,
        provinceOptions
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            onActionClick("Submit", values);
    }

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        denominazioneIt: comune?.denominazioneIt ?? "",
                        anprId: comune?.anprId ?? null,
                        codIstat: comune?.codIstat ?? "",
                        provinciaId: comune?.provinciaId ?? "",
                        codCatastale: comune?.codCatastale ?? "",
                        altraDenom: comune?.altraDenom ?? "",
                        altraDenomTraslitterata: comune?.altraDenomTraslitterata ?? "",
                        provinciaIstatId: comune?.provinciaIstatId ?? "",
                        prefetturaId: comune?.prefetturaId ?? "",
                        stato: comune?.stato ?? "",
                        fonte: comune?.fonte ?? "",
                        codDenom: comune?.codDenom ?? "",
                        dataIstituzione: comune?.dataIstituzione ?? null,
                        dataCessazione: comune?.dataCessazione ?? null,
                        cap: comune?.cap ?? "",
                    }
                }
                enableReinitialize
                validationSchema={ComuneSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{ color: "white", backgroundColor: "secondary.main", }}
                                        title={
                                            <Grid container alignItems="center" justifyContent="space-between" >
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                                <Grid item>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Denominazione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="denominazioneIt"
                                                            name="denominazioneIt"
                                                            value={values.denominazioneIt}
                                                            onChange={handleChange}
                                                            error={touched.denominazioneIt && Boolean(errors.denominazioneIt)}
                                                            helperText={touched.denominazioneIt && errors.denominazioneIt}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        ANPR id
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="anprId"
                                                            name="anprId"
                                                            type="number"
                                                            value={values.anprId}
                                                            onChange={handleChange}
                                                            error={touched.anprId && Boolean(errors.anprId)}
                                                            helperText={touched.anprId && errors.anprId}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice istat
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codIstat"
                                                            name="codIstat"
                                                            value={values.codIstat}
                                                            onChange={handleChange}
                                                            error={touched.codIstat && Boolean(errors.codIstat)}
                                                            helperText={touched.codIstat && errors.codIstat}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Provincia
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="provinciaId"
                                                            component={Autocomplete}
                                                            options={provinceOptions}
                                                            onChange={(e, value) => {
                                                                setFieldValue('provinciaId', value?.provinciaId);
                                                            }}
                                                            value={provinceOptions.find(option => option.provinciaId == values.provinciaId) ?? null}
                                                            renderInput={(params) => <TextField {...params} label="Scegli..." />}
                                                            fullWidth
                                                        />
                                                        {
                                                            errors.provinciaId &&
                                                            <Typography color="error">
                                                                {errors.provinciaId}
                                                            </Typography>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice postale
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="cap"
                                                            name="cap"
                                                            value={values.cap}
                                                            onChange={handleChange}
                                                            error={touched.cap && Boolean(errors.cap)}
                                                            helperText={touched.cap && errors.cap}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice postale importato
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>
                                                            {comune?.capci}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice catastale
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codCatastale"
                                                            name="codCatastale"
                                                            value={values.codCatastale}
                                                            onChange={handleChange}
                                                            error={touched.codCatastale && Boolean(errors.codCatastale)}
                                                            helperText={touched.codCatastale && errors.codCatastale}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Altra denominazione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="altraDenominazione"
                                                            name="altraDenominazione"
                                                            value={values.altraDenominazione}
                                                            onChange={handleChange}
                                                            error={touched.altraDenominazione && Boolean(errors.altraDenominazione)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Altra denominazione traslitterata
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="altraDenomTraslitterata"
                                                            name="altraDenomTraslitterata"
                                                            value={values.altraDenomTraslitterata}
                                                            onChange={handleChange}
                                                            error={touched.altraDenomTraslitterata && Boolean(errors.altraDenomTraslitterata)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Codice denominazione
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="codDenom"
                                                            name="codDenom"
                                                            value={values.codDenom}
                                                            onChange={handleChange}
                                                            error={touched.codDenom && Boolean(errors.codDenom)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Provincia istat id
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="provinciaIstatId"
                                                            name="provinciaIstatId"
                                                            value={values.provinciaIstatId}
                                                            onChange={handleChange}
                                                            error={touched.provinciaIstatId && Boolean(errors.provinciaIstatId)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Prefettura id
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="prefetturaId"
                                                            name="prefetturaId"
                                                            value={values.prefetturaId}
                                                            onChange={handleChange}
                                                            error={touched.prefetturaId && Boolean(errors.prefetturaId)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Stato
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="stato"
                                                            name="stato"
                                                            value={values.stato}
                                                            onChange={handleChange}
                                                            error={touched.stato && Boolean(errors.stato)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fonte
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="fonte"
                                                            name="fonte"
                                                            value={values.fonte}
                                                            onChange={handleChange}
                                                            error={touched.fonte && Boolean(errors.fonte)}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Data istituzione
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="dataIstituzione"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('dataIstituzione', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('dataIstituzione', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1800, 1, 1])}
                                                            value={values.dataIstituzione}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Data cessazione
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="dataCessazione"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('dataCessazione', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('dataCessazione', null);
                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1800, 1, 1])}
                                                            value={values.dataCessazione}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={comune?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={comune?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={comune?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={comune?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}